import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Header } from 'src/components'
import { CustomButton, TransactionInput } from 'src/components/ui'
import Toast from 'src/components/ui/Toast/Toast'
import { useChangeBackground } from 'src/hooks/useChangeBackground'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import { useJoinToBottle } from '../../hooks/useJoinToBottle'
import ContributionConfirmationModal from '../ContributionConfirmationModal/ContributionConfirmationModal'
import styles from './AttachmentToBottle.module.scss'

const AttachmentToBottle = () => {
  const [inputValue, setInputValue] = React.useState<string>('')
  const [isActiveModal, setIsActiveModal] = React.useState<boolean>(false)
  const [isActiveLoading, setIActiveLoading] = React.useState<boolean>(false)

  const [notEnoughStars, setNotEnoughStars] = React.useState<boolean>(false)

  const { id } = useParams()

  const balanceStars = useGlobalStore((store) => store.user?.balance_stars) || 0
  const { t } = useTranslation()

  useChangeBackground(styles['blue-background'])

  const limitExchangeTickets = localStorage.getItem('numberStarsToTickets') === '10'

  const { joinToBottle } = useJoinToBottle(Number(inputValue))

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setInputValue(value)

    e.target.style.width = `${Math.max(value.length, 1)}ch`

    if (Number(value) > balanceStars) {
      setNotEnoughStars(true)
    } else {
      setNotEnoughStars(false)
    }
  }

  return (
    <>
      <Header variant='back' path={`/bottles/${id}`}></Header>
      <Toast isVisible={notEnoughStars} />

      <Toast isVisible={limitExchangeTickets} type='limit_is_full' />

      <main className={styles.main}>
        <h1>{t('attachment_to_bottle.join_to_bottle')}</h1>
        <p className={styles.subtitle}>{t('attachment_to_bottle.input_amount')}</p>

        <ContributionConfirmationModal
          isActiveModal={isActiveModal}
          isActiveLoading={isActiveLoading}
          setIsActiveModal={setIsActiveModal}
          handleClickWritingStars={joinToBottle}
        />

        <TransactionInput commission={'00.00'} inputValue={inputValue} handleChange={handleChangeInput} />

        <CustomButton
          onClick={() => setIsActiveModal(true)}
          variant={
            inputValue.length === 0 ||
            inputValue.startsWith('0') ||
            +inputValue > 10 ||
            Number(inputValue) > balanceStars ||
            Number(inputValue) <= 0 ||
            limitExchangeTickets
              ? 'not-active'
              : 'contained'
          }
          color='white'
          className={styles.button}
        >
          {t('bottle_page.exchange.stars_for_tickets')}
        </CustomButton>
      </main>
    </>
  )
}

export default AttachmentToBottle
